export const FETCH_CATALOG_REQUEST = "FETCH_CATALOG_REQUEST";
export const FETCH_CATALOG_SUCCESS = "FETCH_CATALOG_SUCCESS";
export const FETCH_CATALOG_FAILURE = "FETCH_CATALOG_FAILURE";
export const FETCH_LEXICAL_REQUEST = "FETCH_LEXICAL_REQUEST";
export const FETCH_LEXICAL_SUCCESS = "FETCH_LEXICAL_SUCCESS";
export const FETCH_LEXICAL_FAILURE = "FETCH_LEXICAL_FAILURE";
export const FETCH_COMPLEMENTATION_REQUEST = "FETCH_COMPLEMENTATION_REQUEST";
export const FETCH_COMPLEMENTATION_SUCCESS = "FETCH_COMPLEMENTATION_SUCCESS";
export const FETCH_COMPLEMENTATION_FAILURE = "FETCH_COMPLEMENTATION_FAILURE";
export const FETCH_SUBSTITUTION_REQUEST = "FETCH_SUBSTITUTION_REQUEST";
export const FETCH_SUBSTITUTION_SUCCESS = "FETCH_SUBSTITUTION_SUCCESS";
export const FETCH_SUBSTITUTION_FAILURE = "FETCH_SUBSTITUTION_FAILURE";
export const FETCH_CITATION_REQUEST = "FETCH_CITATION_REQUEST";
export const FETCH_CITATION_SUCCESS = "FETCH_CITATION_SUCCESS";
export const FETCH_CITATION_FAILURE = "FETCH_CITATION_FAILURE";
export const FETCH_MAIN_CATALOG_REQUEST = "FETCH_MAIN_CATALOG_REQUEST";
export const FETCH_MAIN_CATALOG_SUCCESS = "FETCH_MAIN_CATALOG_SUCCESS";
export const FETCH_MAIN_CATALOG_FAILURE = "FETCH_MAIN_CATALOG_FAILURE";

export const SET_CATALOG_PARAMS = "SET_CATALOG_PARAMS";
